/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  CheckCircleFilled,
  DeleteOutlined,
  FolderOutlined,
  FullscreenExitOutlined,
  LoadingOutlined,
  SaveOutlined,
  UploadOutlined,
  WarningFilled,
} from '@ant-design/icons';
import { Button, Form, Modal, Progress, Spin, TimePicker } from 'antd';
import Text from 'antd/lib/typography/Text';
import moment from 'moment';
import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import InputTag from '../../components/InputTag';
import * as SERVICE from '../../constants/service.types';
import { NOTIFIES } from '../../constants/system.keys';
import {
  getResetUploadFileReturn,
  openMessage,
  setOpenUploadFilesModal,
  setUploadFilesCamera,
  setUploadFilesDate,
  setUploadFilesOldVideos,
  socketEmitEvent,
} from '../../redux/actions';
import './index.scss';

const layout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
};

const UploadVideoCamera = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    uploadFilesCamera,
    uploadFilesDate,
    uploadFilesOldVideos,
    namespace,
    requestUploadFile,
    uploadStorageFile,
    socketState,
  } = useSelector((state) => state);
  const [isCollapse, setIsCollapse] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [isUploadFilesSuccess, setIsUploadFilesSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [isLoadingReadFiles, setIsLoadingReadFiles] = useState(false); // loading when reading files from local

  const [form] = Form.useForm();

  const currentFile = useRef(null);
  const [isSubmittedForm, setIsSubmitedForm] = useState(false);

  const inputUploadFileRef = useRef();
  const inputUploadFolderRef = useRef();

  const dataVideoTimes = useMemo(
    () =>
      uploadFilesOldVideos?.map((item) => ({
        from: moment(
          `${moment(uploadFilesDate).format('DD-MM-YYYY')} ${item.from}`,
          'DD-MM-YYYY hh:mm:ss'
        ).valueOf(),
        to: moment(
          `${moment(uploadFilesDate).format('DD-MM-YYYY')} ${item.to}`,
          'DD-MM-YYYY hh:mm:ss'
        ).valueOf(),
      })) ?? [],
    [uploadFilesDate, uploadFilesOldVideos]
  );

  const handleErrorWhileUploading = (errMessage) => {
    const currentFileIndex = form
      .getFieldValue('listFileVideo')
      ?.findIndex((item) => item.id === currentFile.current.id);
    if (currentFileIndex !== undefined) {
      form.setFields([
        {
          name: ['listFileVideo', currentFileIndex, 'status'],
          value: {
            loadingPercent: null,
            isUploadSuccess: false,
            error: errMessage,
          },
        },
      ]);
    }
    setError(errMessage);
    setIsLoad(false);
  };

  useEffect(() => {
    if (socketState === -1) {
      handleErrorWhileUploading(t('Lost connection to server'));
    }
  }, [socketState]);

  const findLastStartTime = () => {
    return dataVideoTimes?.length
      ? moment.max(
        uploadFilesOldVideos.map((item) =>
          moment(
            `${moment(uploadFilesDate).format('DD-MM-YYYY')} ${item.to}`,
            'DD-MM-YYYY hh:mm:ss'
          )
        )
      )
      : moment(uploadFilesDate).startOf('day');
  };

  const checkValidFileUpload = (file) => {
    const dataDuration = currentFile.current.momentVideoDuration.hour() * 60 * 60 +
      currentFile.current.momentVideoDuration.minute() * 60 +
      currentFile.current.momentVideoDuration.second()
    let data = {
      serial: uploadFilesCamera?.serial,
      namespace,
      recordDate: uploadFilesDate.format('DD-MM-YYYY'),
      serviceId: 10,
      fileSize: Math.ceil(file.size / 1024),
      duration: dataDuration,
      hour: moment(uploadFilesDate).format('HH') ? Number(moment(uploadFilesDate).format('HH')) : 0,
      minute: moment(uploadFilesDate).format('HH') ? Number(moment(uploadFilesDate).format('mm')) : 0,
      contentType: file.type ?? 'video/mp4',
    };
    let dataObj = {
      appServiceType: SERVICE.REQUEST_UPLOAD_FILE,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    try {
      dispatch(socketEmitEvent(dataObj));
    } catch (err) {
    }
  };

  const handleSubmitVideos = (formValues) => {
    if (formValues.listFileVideo.length > 0) {
      setIsUploadFilesSuccess(false);
      setError(null);
      setIsLoad(true);
      setIsSubmitedForm(true);
      currentFile.current = formValues.listFileVideo.find(
        (item) => !item.status.isUploadSuccess
      );
      checkValidFileUpload(currentFile.current.file);
    }
  };

  // thành công -> trả về thời lượng của video (theo giây), thất bại -> null
  const getVideoDuration = (videoFile) => {
    return new Promise((resolve) => {
      let video = document.createElement('video');
      video.preload = 'metadata';
      video.onloadedmetadata = function () {
        resolve(video.duration);
      };
      video.onerror = function () {
        resolve(null);
      };
      video.src = window.URL.createObjectURL(videoFile);
    });
  };

 
  const handleUploadFileToS3 = async (videoFile, videoDuration, onProgress) => {
    const dataCofig = requestUploadFile.data;
    const dataDate = moment().valueOf();
  
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', `${dataCofig?.uploadConfig?.uploadUrl}`, true);
      xhr.setRequestHeader("Content-Type", "video/mp4");
  
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percentComplete = Math.round((event.loaded / event.total) * 100);
          onProgress(percentComplete);
        }
      };
  
      xhr.onload = () => {
        if (xhr.status === 200) {
          const s3Data = {
            serial: uploadFilesCamera?.serial,
            namespace,
            fileName: `${uploadFilesCamera?.serial}_${dataDate}.mp4`,
            duration: videoDuration,
            size: Math.ceil(videoFile.size / 1024),
            bucketName: namespace,
            objectName: dataCofig?.uploadConfig?.objectName,
            accountServiceId: dataCofig?.accountServiceId
          };
          resolve(s3Data);
        } else {
          reject(new Error('Upload failed'));
        }
      };
  
      xhr.onerror = () => reject(new Error('Upload failed'));
  
      xhr.send(videoFile);
    });
  };

  const handleSaveCurrentFileInfoToServer = async (s3Data) => {
    let videoThumbnail;
    videoThumbnail = '';
    if (s3Data) {
      const data = {
        ...s3Data,
        timestamp: moment(uploadFilesDate)
          .set({
            hour: moment(currentFile.current.time).format('HH'),
            minute: moment(currentFile.current.time).format('mm'),
            second: 0,
          })
          .valueOf(),
        thumbnail: videoThumbnail ?? '',
        tag: currentFile.current.tags?.join(';') ?? '',
      };

      let dataObj = {
        appServiceType: SERVICE.UPLOAD_STORAGE_FILE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    } else {
      handleErrorWhileUploading(t('File upload failed'));
    }
  };

  const handleUpload = async () => {
    const currentFileIndex = form
      .getFieldValue('listFileVideo')
      ?.findIndex((item) => item.id === currentFile.current.id);

    if (requestUploadFile.isSuccess) {
      try {
        form.setFields([
          {
            name: ['listFileVideo', currentFileIndex, 'status'],
            value: {
              loadingPercent: 0,
              isUploadSuccess: null,
              error: null,
            },
          },
        ]);
        // TODO sửa lại logic args
        const s3Data = await handleUploadFileToS3(
          currentFile.current.file,
          currentFile.current.momentVideoDuration.hour() * 60 * 60 +
          currentFile.current.momentVideoDuration.minute() * 60 +
          currentFile.current.momentVideoDuration.second(),
          (percent) => {
            form.setFields([
              {
                name: ['listFileVideo', currentFileIndex, 'status'],
                value: {
                  loadingPercent: percent,
                  isUploadSuccess: null,
                  error: null,
                },
              },
            ]);
          }
        );
        handleSaveCurrentFileInfoToServer(s3Data);
      } catch (err) {
        handleErrorWhileUploading(
          err.message || t('There was an error while uploading the file')
        );
      }
    } else {
      handleErrorWhileUploading(requestUploadFile.message);
    }
  };

  const handleChangeFilesUpload = async (e) => {
    const listVideos = [...e.target.files];

    if (listVideos.length > 1000) {
      openMessage(NOTIFIES.WARNING, t('Only allow uploading up to 1000 files'));
      return;
    }
    setIsLoadingReadFiles(true);

    try {
      const listStartTime = [];
      // read file data
      const listVideoDuration = await Promise.all(
        listVideos.map((videoFile) => getVideoDuration(videoFile))
      );

      for (let index = 0; index < listVideos.length; index++) {
        if (index === 0) {
          listStartTime.push(findLastStartTime());
        } else {
          listStartTime.push(
            listStartTime[index - 1]
              .clone()
              .add(Math.floor(listVideoDuration[index - 1] / 60) + 1, 'minutes')
          );
        }
      }

      const listSortedVideo = [];

      listVideos
        .map((file, index) => ({
          id: index,
          time: listStartTime[index],
          tags: file.name ? [file.name] : [],
          file,
          videoDuration: listVideoDuration[index],
          momentVideoDuration: listVideoDuration[index]
            ? moment.utc(listVideoDuration[index] * 1000)
            : null,
          status: {
            loadingPercent: null, // phần trăm upload lên s3
            isUploadSuccess: null, // trạng thái upload file thành công hay thất bại
            error: null, // lỗi xảy ra khi upload file
          },
        }))
        .forEach((item) => {
          if (item.videoDuration === null) listSortedVideo.unshift(item);
          else listSortedVideo.push(item);
        });

      form.setFieldsValue({
        listFileVideo: listSortedVideo,
      });

      setIsSubmitedForm(false);
    } catch (err) {
      openMessage(NOTIFIES.WARNING, err.message);
    }

    setIsLoadingReadFiles(false);
  };

  useEffect(() => {
    if (requestUploadFile) {
      handleUpload();
    }
  }, [requestUploadFile]);

  useEffect(() => {
    if (uploadStorageFile) {
      if (uploadStorageFile.isSuccess) {
        const currentFileIndex = form
          .getFieldValue('listFileVideo')
          ?.findIndex((item) => item.id === currentFile.current.id);
        form.setFields([
          {
            name: ['listFileVideo', currentFileIndex, 'status'],
            value: {
              loadingPercent: 100,
              isUploadSuccess: true,
              error: null,
            },
          },
        ]);
        currentFile.current = null; // free
        // handle upload next video
        const videoFileNext = form
          .getFieldValue('listFileVideo')
          .find((item) => !item.status.isUploadSuccess && !item.status.error);
        if (videoFileNext) {
          currentFile.current = videoFileNext;
          checkValidFileUpload(currentFile.current.file);
        } else {
          // upload all file success!
          setIsUploadFilesSuccess(true);
          setIsLoad(false);
        }
      } else {
        handleErrorWhileUploading(uploadStorageFile.message);
      }
    }
  }, [uploadStorageFile]);

  const handleCancelUpload = () => {
    dispatch(getResetUploadFileReturn());
    setIsCollapse(false);
    dispatch(setOpenUploadFilesModal(false));
    dispatch(setUploadFilesCamera(null));
    dispatch(setUploadFilesDate(null));
    dispatch(setUploadFilesOldVideos(null));
  };

  const handleCollapseUpload = () => {
    setIsCollapse(true);
  };

  const progressUploadTitle = `${form
    .getFieldValue('listFileVideo')
    ?.filter((item) => item.status.isUploadSuccess)?.length || 0
    }/${form.getFieldValue('listFileVideo')?.length || 0} files`;

  return (
    <>
      <Modal
        title={t('Upload video') + ` (${uploadFilesCamera?.name})` ?? ''}
        className="modal-upload-video"
        style={{ top: 64 }}
        width="80vw"
        bodyStyle={{ minHeight: '35vh' }}
        visible={!isCollapse}
        onCancel={
          // nếu upload thành công, hoặc không có video nào -> clear dialog
          isUploadFilesSuccess || !form.getFieldValue('listFileVideo')?.length
            ? handleCancelUpload
            : handleCollapseUpload
        }
        footer={null}
        maskClosable={false}
      >
        <div className="upload-video-camera-container">
          <Form form={form} {...layout} onFinish={handleSubmitVideos}>
            <p>
              <span style={{ fontSize: 15 }}>Date:</span>{' '}
              {moment(uploadFilesDate).format('DD-MM-YYYY')}
            </p>

            <Button
              className="button-upload"
              onClick={() => inputUploadFileRef.current.click()}
              icon={<UploadOutlined />}
              disabled={isLoad}
            >
              {t('Upload Files')}
            </Button>
            <Button
              className="button-upload"
              onClick={() => inputUploadFolderRef.current.click()}
              icon={<FolderOutlined />}
              disabled={isLoad}
            >
              {t('Upload Folder')}
            </Button>
            <input
              type="file"
              multiple
              onChange={(e) => {
                handleChangeFilesUpload(e);
                inputUploadFileRef.current.value = '';
              }}
              className="input-upload"
              id="input-upload-file"
              ref={inputUploadFileRef}
              accept="video/mp4,video/x-m4v,video/*"
            />
            <input
              type="file"
              webkitdirectory="true"
              onChange={(e) => {
                handleChangeFilesUpload(e);
                inputUploadFolderRef.current.value = '';
              }}
              mozdirectory="true"
              multiple
              className="input-upload"
              ref={inputUploadFolderRef}
              accept="video/mp4,video/x-m4v,video/*"
            />
            {isLoadingReadFiles && (
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              />
            )}

            <Form.List name="listFileVideo">
              {(fields, { remove }) => (
                <>
                  {form.getFieldValue('listFileVideo')?.length > 0 && (
                    <Text>Uploaded: {progressUploadTitle}</Text>
                  )}
                  {fields.length > 0 && (
                    <div className="table-upload-container">
                      <table>
                        <thead>
                          <tr>
                            <td>{t('Start time')}</td>
                            <td>{t('Tags')}</td>
                            <td>{t('Info')}</td>
                            <td>{t('Video duration')}</td>
                            <td>{t('Upload status')}</td>
                            <td></td>
                          </tr>
                        </thead>
                        <tbody>
                          {fields.map((field) => (
                            <tr key={field.key}>
                              <td>
                                <div className="align-center">
                                  <Form.Item
                                    {...field}
                                    name={[field.name, 'time']}
                                    rules={[
                                      {
                                        required: true,
                                        message: t('Required'),
                                      },
                                    ]}
                                  >
                                    <TimePicker
                                      style={{ width: '100%' }}
                                      format="HH:mm"
                                      placeholder={t('Select time')}
                                      disabled={isSubmittedForm}
                                    />
                                  </Form.Item>
                                </div>
                              </td>
                              <td>
                                <Form.Item
                                  {...field}
                                  name={[field.name, 'tags']}
                                >
                                  <InputTag
                                    numberTag={10}
                                    nameAdd="Add tag"
                                    containerStyle={{ marginLeft: 0 }}
                                    disabled={isSubmittedForm}
                                  />
                                </Form.Item>
                              </td>

                              <td>
                                <Form.Item
                                  {...field}
                                  name={[field.name, 'file']}
                                >
                                  <FileInfo />
                                </Form.Item>
                              </td>
                              <td>
                                <Form.Item
                                  {...field}
                                  name={[field.name, 'momentVideoDuration']}
                                  rules={[
                                    {
                                      validator: (_, value) => {
                                        if (value) {
                                          return value.hour() * 60 * 60 +
                                            value.minute() * 60 +
                                            value.second() >=
                                            1
                                            ? Promise.resolve()
                                            : Promise.reject(
                                              new Error(
                                                t('At least 1 second')
                                              )
                                            );
                                        }
                                        return Promise.reject(
                                          new Error(t('Required'))
                                        );
                                      },
                                    },
                                  ]}
                                >
                                  <TimePicker
                                    style={{ width: '100%' }}
                                    format="HH:mm:ss"
                                    placeholder={t('Duration')}
                                    disabled={isSubmittedForm}
                                  />
                                </Form.Item>
                              </td>

                              <td>
                                {
                                  <Form.Item
                                    {...field}
                                    name={[field.name, 'status']}
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <UploadStatus />
                                  </Form.Item>
                                }
                              </td>
                              <td className="table-actions">
                                {
                                  <Form.Item
                                    {...field}
                                    name={[field.name, 'status']}
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <RemoveVideoFileField
                                      onClick={() => remove(field.name)}
                                      isLoad={isLoad}
                                    />
                                  </Form.Item>
                                }
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  <div className="update-camera-footer">
                    {form
                      .getFieldValue('listFileVideo')
                      ?.some((item) => !item.status.isUploadSuccess) && (
                        <>
                          <Button onClick={handleCancelUpload}>
                            {t('Cancel')}
                          </Button>
                          <Button
                            onClick={handleCollapseUpload}
                            icon={<FullscreenExitOutlined />}
                            type="primary"
                          >
                            {t('Collapse')}
                          </Button>
                          <Form.Item shouldUpdate={true}>
                            {() => (
                              <Button
                                icon={<SaveOutlined />}
                                htmlType="submit"
                                type="primary"
                                loading={isLoad}
                                disabled={
                                  isLoad ||
                                  form
                                    .getFieldsError()
                                    .some((item) => item.errors.length > 0)
                                }
                              >
                                {t('Submit')}
                              </Button>
                            )}
                          </Form.Item>
                        </>
                      )}
                  </div>
                </>
              )}
            </Form.List>
          </Form>
        </div>
      </Modal>

      <div
        className="upload-file-collapse-container"
        style={{ display: isCollapse ? 'inline-flex' : 'none' }}
        onClick={() => {
          setIsCollapse(false);
          dispatch(setOpenUploadFilesModal(true));
        }}
      >
        {isLoad && <UploadFileSpinner />}
        <div
          className="upload-file-collapse-title"
          style={{
            backgroundColor: isUploadFilesSuccess
              ? 'green'
              : error
                ? '#ff4d4d'
                : 'rgba(240, 156, 60, 0.9)',
          }}
        >
          <span>
            {isUploadFilesSuccess
              ? 'Upload done!'
              : error
                ? 'Upload fail!'
                : progressUploadTitle}
          </span>
        </div>
      </div>
    </>
  );
};

const FileInfo = ({ value }) => (
  <>
    <div>Name: {value.name}</div>
    <div>Size: {(value.size / (1024 * 1024)).toFixed(2)} MB</div>
  </>
);

const UploadStatus = ({ value }) => {
  return (
    <>
      {value.isUploadSuccess && (
        <>
          Success <CheckCircleFilled className="icon-done" />
        </>
      )}

      {value.loadingPercent !== null &&
        value.loadingPercent !== 100 &&
        !value.isUploadSuccess &&
        !value.error && (
          <>
            <Progress percent={value.loadingPercent} showInfo={false} />
            {value.loadingPercent}%
          </>
        )}

      {value.loadingPercent === 100 &&
        value.isUploadSuccess === null &&
        !value.error && (
          <>
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />}
            />{' '}
            <span>Saving...</span>
          </>
        )}

      {value.error && !value.isUploadSuccess && (
        <div>
          Fail
          <WarningFilled className="icon-error" />
          <div>{value.error}</div>
        </div>
      )}
    </>
  );
};

const RemoveVideoFileField = ({ value, onClick, isLoad }) => {
  return (
    <>
      {!value.isUploadSuccess && !isLoad && (
        <DeleteOutlined onClick={onClick} />
      )}
    </>
  );
};

const UploadFileSpinner = () => {
  return (
    <div class="upload-file-spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default memo(UploadVideoCamera);
